import { render, staticRenderFns } from "./staffDialog.vue?vue&type=template&id=6d8e6350&scoped=true&"
import script from "./staffDialog.vue?vue&type=script&lang=js&"
export * from "./staffDialog.vue?vue&type=script&lang=js&"
import style0 from "./staffDialog.vue?vue&type=style&index=0&id=6d8e6350&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8e6350",
  null
  
)

export default component.exports